import { Component } from '@angular/core';
import { environment } from '../../../../src/environments/environment';
import { UserProfileService } from '../../core/services/user-profile.service';
import { UserProfile } from '../../models/user-profile';
import { AdminEnvLabelComponent } from './admin-env-label/admin-env-label.component';
import { LayoutService } from '../layout.service';

@Component({
  standalone: true,
  imports: [AdminEnvLabelComponent],
  selector: 'admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent {
  publicUrl = environment.system.publicUrl;

  get user(): UserProfile | undefined {
    return this.profileSvc.profile;
  }

  constructor(
    public profileSvc: UserProfileService,
    public layoutService: LayoutService
  ) {}
}
